import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const DownloadIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.5 18.8c0-.44.36-.8.8-.8h13.4c.44 0 .8.36.8.8v.9a.8.8 0 0 1-.8.8H5.3a.8.8 0 0 1-.8-.8v-.9Z" /><path d="m17.94 7.94.68.72a.7.7 0 0 1 .22.53c0 .2-.07.38-.21.53l-6.07 6.06a.72.72 0 0 1-.53.22.72.72 0 0 1-.53-.22L5.44 9.72a.72.72 0 0 1-.22-.53.7.7 0 0 1 .22-.53l.68-.72a.64.64 0 0 1 .54-.19c.2 0 .38.07.53.22l3.6 3.75V2.75c0-.2.06-.39.21-.53a.72.72 0 0 1 .53-.22h1a.7.7 0 0 1 .53.22.7.7 0 0 1 .22.53v8.97l3.6-3.75a.72.72 0 0 1 .53-.22c.2-.02.38.04.53.19Z" />
    </SvgIcon>
);
